import { BrandsTable } from '@/components/features/brands/BrandsTable'

export const Brands = () => {
  return (
    <div >
      <BrandsTable />
    </div>
  )
}

export default Brands
